import { BookingNotPermittedMessage } from "PFApp/booking/components/booking_not_permitted_message";
import { SingleBookingDetails } from "PFApp/booking/parts/overview/detail_view/booking_detail/booking_detail_content/booking_siblings/single_booking_details";
import { LoadingDots } from "PFComponents/loading_dots";
import { useBooking } from "PFCore/hooks/queries";
import { useBookingTemplate } from "PFCore/hooks/queries/bookings/booking_templates/use_booking_template";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { RefObject } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingDataItemLimitation, BookingFormMode } from "../booking_form.types";
import { BookingFormValues } from "../booking_form_provider";
import { RangeItem } from "./range_item";

type BookingItemProps = {
  itemIndex: number;
  portalRef: RefObject<HTMLDivElement | null>;
  mode: BookingFormMode;
};

export const BookingItem = ({ itemIndex, portalRef, mode }: BookingItemProps) => {
  const { t } = useTranslation("bookingModule");
  const { getCategory } = useBookingCategories();
  // @ts-ignore
  const { id, bookingTemplateId, limitation } = useWatch<BookingFormValues>({
    name: `bookings.${itemIndex}`
  });

  const isHidden = limitation === BookingDataItemLimitation.Hidden;
  const isReadonly = limitation === BookingDataItemLimitation.Readonly;
  const isReadonlyDifferentContext = limitation === BookingDataItemLimitation.ReadonlyDifferentContext;

  const { data: booking } = useBooking(id, { enabled: isReadonly && !isHidden && !!id });
  const { data: bookingTemplate } = useBookingTemplate(bookingTemplateId, {
    enabled: isReadonly && !isHidden && !!bookingTemplateId
  });

  if (isHidden) {
    return <BookingNotPermittedMessage />;
  }

  if (isReadonly || isReadonlyDifferentContext) {
    return booking ? (
      <SingleBookingDetails
        booking={booking}
        bookingTemplate={bookingTemplate}
        category={getCategory(booking)!}
        warning={isReadonlyDifferentContext ? t("details.editingDifferentContextWarning") : undefined}
      />
    ) : (
      <LoadingDots />
    );
  }

  return <RangeItem itemIndex={itemIndex} portalRef={portalRef} mode={mode} />;
};
